import { Box, Typography, Link } from '@mui/material';

const ListComponent = ({ listItems = [], onItemClick }) => {
  const handleItemClick = (item) => {
    console.log("The name", item.label)
    if (onItemClick) {

      onItemClick(item);
    } else if (item.link) {
      window.location.href = item.link;
    }
  };

  const handleSelection = (item) => {
    console.log("The name", item.label)

  };

  return (
    <Box className='ty_pr_list'>
      {listItems.map((item, index) => (
        // <Typography key={index} className='ty_pr_listItems' onClick={() => handleItemClick(item)}>
        //   {item.link ? (
        //     <Link href={item.link} onClick={(e) => e.preventDefault()}>
        //       {item.label}
        //     </Link>
        //   ) : (
        //     item.label
        //   )}
        // </Typography>

        <Typography onClick={(e) => handleItemClick(item, e)}
          key={index}
          className="ty_pr_listItems"
          sx={{
            width: "max-content"
          }}>
          <Link
            href={item.link || "#"}
            underline="none"
          >
            {item.label}
          </Link>
        </Typography>

      ))}
    </Box>
  );
};

export default ListComponent;
